import { render, staticRenderFns } from "./SuccessSubmitForm1.vue?vue&type=template&id=40fbd3b4&scoped=true"
import script from "./SuccessSubmitForm1.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fbd3b4",
  null
  
)

export default component.exports